import { useEffect, useRef } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { curSym } from "../../utils/pip";

const NuStarSubscription = () => {
  const user = { name: "founder-coaching", role: "coach" };
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    dispatch(fetchCoachList());
  }, []);

  const displayUsers = coachList?.filter((item) => {
    const matchCoachingType = item?.category_name
      ?.toLowerCase()
      .includes("founder");
    return matchCoachingType;
  });

  if (isLoading2) {
    return <Loader />;
  }
  return (
    <MenuLayout user={user}>
      {({ openSignUp }) => (
        <>
          <section
            class="ct_nuglow_subsciption_left_bg"
            style={{ backgroundColor: "#8ECAE6" }}
          >
            <div class="">
              <div class="ct_grid_nuglow_2_new">
                <div className="h-100">
                  <img
                    src="assets/img/nuStar_subswcription_left_bnr_img.png"
                    className="ct_img_h_371 h-100" style={{ minHeight: "373px" }}
                  />
                </div>
                <div className="">
                  <div className="ct_pt_60_px_37_pb_52">
                    <h2
                      className="ct_fs_32 ct_mb_50 ct_darkblue_text"
                      style={{ maxWidth: "500px" }}
                    >
                      Lead the{" "}
                      <span className="ct_darksky_blue_text">Future</span> of
                      Freelancing
                    </h2>
                    <p
                      className=" ct_dark_blue_text ct_fs_18"
                      style={{ maxWidth: "457px" }}
                    >
                      Unlock exclusive opportunities, connect with industry
                      leaders, and shape your legacy
                    </p>
                    <div className="mt-4">
                      <a className="ct_yellow_btn ct_darkblue_btn ct_px_80 ct_fit_content ">
                        View packages
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="ct_px_40 ct_mt_100">
            <div className="container-fluid">
              <div className="row ct_mb_50">
                <div className="col-md-12">
                  <h3 className="ct_fs_40 ct_darksky_blue_text mb-4">NuStar</h3>
                  <p className="ct_fs_25 mb-0" style={{ maxWidth: "1310px" }}>
                    NuStar is designed for elite professionals ready to elevate
                    their careers to new heights. With access to high-profile
                    projects, exclusive networking opportunities, and
                    personalized mentorship, NuStar empowers top-tier talents to
                    shape their legacy.
                  </p>
                </div>
              </div>
              <div className="row justify-content-between">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-5 mb-md-0">
                  <div className="ct_plan_feature_card_light_blue ct_mb_50">
                    <h4 className="ct_fs_30 ct_darkblue_text ct_mb_20">
                      Plan Features
                    </h4>
                    <ul className="ps-4" style={{ listStyle: "disc" }}>
                      <li className="ct_darkblue_text ct_fs_20">
                        High-profile projects with elite clients
                      </li>
                      <li className="ct_darkblue_text ct_fs_20 mt-1">
                        Access to industry masterclasses & leadership programs
                      </li>
                      <li className="ct_darkblue_text ct_fs_20 mt-1">
                        Mentorship from top professionals
                      </li>
                      <li className="ct_darkblue_text ct_fs_20 mt-1">
                        Personalized business growth strategies
                      </li>
                      <li className="ct_darkblue_text ct_fs_20 mt-1">
                        Invitation-only networking & community access
                      </li>
                    </ul>
                  </div>
                  <div className="ct_plan_feature_card_light_blue ">
                    <h4 className="ct_fs_30 ct_darkblue_text ct_mb_20">
                      Plan Benefits
                    </h4>
                    <ul className="ps-4" style={{ listStyle: "disc" }}>
                      <li className="ct_darkblue_text ct_fs_20">
                        Shape Your Legacy – Elevate your brand with exclusive
                        projects
                      </li>
                      <li className="ct_darkblue_text ct_fs_20 mt-1">
                        Access Premium Opportunities – Connect with elite
                        clients
                      </li>
                      <li className="ct_darkblue_text ct_fs_20 mt-1">
                        Mentor & Inspire – Join a community of leaders
                      </li>
                      <li className="ct_darkblue_text ct_fs_20 mt-1">
                        Achieve Growth – Get tailored strategies for success
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xxl-4 col-xl-4 col-lg-5 col-md-6 mb-5 mb-md-0">
                  <div className="ct_free_trial_bg">
                    <h4 className="ct_fs_30 text-center ct_darkblue_text ct_mb_30">
                      {curSym} 80.00 per month
                    </h4>
                    <button
                      className="ct_yellow_btn ct_orange_btn ct_px_80 mx-auto"
                      onClick={(e) => {
                        e.preventDefault();
                        openSignUp();
                      }}
                    >
                      Upgrade Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            data-aos="fade-right"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg      ct_p_111_y_106 ct_mt_100"
            style={{ backgroundColor: "#219EBC" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">
                  Elevate Your Freelance Career to Legendary Status
                </h4>
                <p class="mb-0 ct_fs_18 ct_fw_300">
                  Access exclusive opportunities, expert mentorship, and
                  top-tier projects.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  onClick={() => navigate(coachPaths?.ContactUs, { state: { data: "landing" } })}
                >
                  Contact Us
                </a>
              </div>
            </div>
          </section>

          <section className="ct_pt_130 px-5">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="ct_fs_32 text-center">
                    Choose the Right{" "}
                    <span className="ct_darksky_blue_text">NuStar</span> Plan
                    For You
                  </h4>
                </div>
              </div>
              <div class="row ct_mt_60">
                <div class="col-lg-4  mb-4 mb-lg-0">
                  <div
                    class="ct_pricing_card bg-white"
                    style={{ borderColor: "#8ECAE6" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="mb-2 ct_fs_20_new ct_darkblue_text">
                          Starter Access
                        </p>
                        <h2 class="mb-0">
                          <span className="ct_fs_44   ct_fw_600">{curSym} 20</span>{" "}
                          <span className="ct_fs_18">/1 Month</span>{" "}
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18">
                          Kickstart your freelance journey.
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18 mt-1">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Entry-level project access
                        </li>
                        <li className="ct_fs_18 mt-1">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Build portfolio fast
                        </li>
                        <li className="ct_fs_18 mt-1">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Verified client connections
                        </li>
                        <li className="ct_fs_18 mt-1">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Collect client reviews
                        </li>
                        <li className="ct_fs_18 mt-1">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          24/7 basic support
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a
                        class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                        onClick={(e) => {
                          e.preventDefault()
                          openSignUp()
                        }}
                      >
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 mb-4 mb-lg-0">
                  <div
                    class="ct_pricing_card bg-white"
                    style={{ borderColor: "#8ECAE6" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                          <p class="mb-2 ct_fs_20_new ct_darkblue_text">
                            Pro Builder
                          </p>
                          <span
                            class="ct_most_popular_badge ct_flex_shrink_0"
                            style={{
                              backgroundColor: "var(--dark_blue) ",
                              color: "#fff",
                            }}
                          >
                            Most Popular
                          </span>
                        </div>
                        <h2 class="ct_fs_44  mb-0 ct_fw_600">
                          <span className="ct_fs_44   ct_fw_600">{curSym} 80</span>{" "}
                          <span className="ct_fs_18">/3 Month</span>{" "}
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ">
                          Grow faster and stand out.
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Priority project access
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Boosted profile visibility
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Skills webinars access
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Verified client matches
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Community support
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a
                        class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                        onClick={(e) => {
                          e.preventDefault()
                          openSignUp()
                        }}
                      >
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4  mb-4 mb-lg-0">
                  <div
                    class="ct_pricing_card bg-white"
                    style={{ borderColor: "#8ECAE6" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="mb-2 ct_fs_20_new ct_darkblue_text">
                          Elite Creator
                        </p>
                        <h2 class="ct_fs_44  mb-0 ct_fw_600">
                          <span className="ct_fs_44   ct_fw_600">{curSym} 100</span>{" "}
                          <span className="ct_fs_18">/1 Year</span>{" "}
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          Unlock full potential and premium access
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Access premium projects
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Personalized profile review
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Early access to new features
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Dedicated success support
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Verified Nuvio badge
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a
                        class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                        onClick={(e) => {
                          e.preventDefault()
                          openSignUp()
                        }}
                      >
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="ct_mt_30">
                <a className="ct_yellow_outline_btn_shadow ct_fs_14">
                  Other Plans<i class="fa-solid fa-arrow-right ms-2"></i>{" "}
                </a>
              </div>
            </div>
          </section>

          <div className="ct_nuglow_yellow_shape_main_34 ct_nuforge_lightblue_shape_main_34  ct_mb_100 ">
            <section class="  ct_px_40 ct_py_130 ">
              <div class="container-fluid">
                <div class="row">
                  <div
                    class="col-lg-4 mb-4 mb-lg-0"
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div class="d-grid h-100 pt-2 pb-5">
                      <h2
                        class="ct_fs_40 ct_darkblue_text"
                        style={{ maxWidth: "300px" }}
                      >
                        Real Stories, real{" "}
                        <span style={{ color: "#FFB703" }}>success</span>
                      </h2>
                      <div className="ct_arrows mt-auto">
                        <button className="ct_prev ct_arrow_btn" ref={prevRef}>
                          <i class="fa-solid fa-arrow-left"></i>
                        </button>
                        <button className="ct_next ct_arrow_btn" ref={nextRef}>
                          <i class="fa-solid fa-arrow-right"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-8 mb-4 mb-lg-0"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <Swiper
                      modules={[Navigation, Autoplay]}
                      spaceBetween={20}
                      slidesPerView={1}
                      loop={true}
                      autoplay={{ delay: 2500 }}
                      navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                      }}
                      onBeforeInit={(swiper) => {
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                      }}
                      className="ct_real_stories_slider"
                    >
                      {/* Slide 1 */}
                      <SwiperSlide>
                        <div className="ct_story_slide_card">
                          <div className="ct_story_user_img">
                            <img
                              src="assets/img/real_succss_img_457.png"
                              alt=""
                            />
                          </div>
                          <div>
                            <div className="ct_orange_text mb-3">
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                            </div>

                            <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                              Climbing Higher with Every Project
                            </h3>

                            <p
                              className="ct_fS_18 ct_darkblue_text"
                              style={{ maxWidth: "402px" }}
                            >
                              NuStar gave me access to exclusive projects that
                              truly challenged and grew my expertise. Today, I
                              lead innovative product initiatives and mentor
                              upcoming tech talents
                            </p>

                            <div className="mt-5">
                              <h4 className="ct_fs_20 ct_darkblue_text">
                                Chloe Adams
                              </h4>
                              <p className="ct_fs_18 ct_darkblue_text">
                                Product Director at Zenith Tech
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="ct_story_slide_card">
                          <div className="ct_story_user_img">
                            <img
                              src="assets/img/real_succss_img_457.png"
                              alt=""
                            />
                          </div>
                          <div>
                            <div className="ct_orange_text mb-3">
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                            </div>

                            <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                              Climbing Higher with Every Project
                            </h3>

                            <p
                              className="ct_fS_18 ct_darkblue_text"
                              style={{ maxWidth: "402px" }}
                            >
                              NuStar gave me access to exclusive projects that
                              truly challenged and grew my expertise. Today, I
                              lead innovative product initiatives and mentor
                              upcoming tech talents
                            </p>

                            <div className="mt-5">
                              <h4 className="ct_fs_20 ct_darkblue_text">
                                Chloe Adams
                              </h4>
                              <p className="ct_fs_18 ct_darkblue_text">
                                Product Director at Zenith Tech
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="ct_story_slide_card">
                          <div className="ct_story_user_img">
                            <img
                              src="assets/img/real_succss_img_457.png"
                              alt=""
                            />
                          </div>
                          <div>
                            <div className="ct_orange_text mb-3">
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                            </div>

                            <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                              Climbing Higher with Every Project
                            </h3>

                            <p
                              className="ct_fS_18 ct_darkblue_text"
                              style={{ maxWidth: "402px" }}
                            >
                              NuStar gave me access to exclusive projects that
                              truly challenged and grew my expertise. Today, I
                              lead innovative product initiatives and mentor
                              upcoming tech talents
                            </p>

                            <div className="mt-5">
                              <h4 className="ct_fs_20 ct_darkblue_text">
                                Chloe Adams
                              </h4>
                              <p className="ct_fs_18 ct_darkblue_text">
                                Product Director at Zenith Tech
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="ct_story_slide_card">
                          <div className="ct_story_user_img">
                            <img
                              src="assets/img/real_succss_img_457.png"
                              alt=""
                            />
                          </div>
                          <div>
                            <div className="ct_orange_text mb-3">
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                            </div>

                            <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                              Climbing Higher with Every Project
                            </h3>

                            <p
                              className="ct_fS_18 ct_darkblue_text"
                              style={{ maxWidth: "402px" }}
                            >
                              NuStar gave me access to exclusive projects that
                              truly challenged and grew my expertise. Today, I
                              lead innovative product initiatives and mentor
                              upcoming tech talents
                            </p>

                            <div className="mt-5">
                              <h4 className="ct_fs_20 ct_darkblue_text">
                                Chloe Adams
                              </h4>
                              <p className="ct_fs_18 ct_darkblue_text">
                                Product Director at Zenith Tech
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
              </div>
            </section>
            <section class=" ct_px_40 pt-0 ">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div
                    class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 "
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div class="ct_about_cnt">
                      <h2 class=" ct_fs_32  ct_mb_60">
                        Frequently asked questions
                      </h2>

                      <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                        <div class="accordion" id="faq_accordionExample">
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faq_one">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_one"
                                aria-expanded="false"
                                aria-controls="collapsefaq_one"
                              >
                                What makes NuStar different from other plans?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_one"
                              class="accordion-collapse collapse"
                              aria-labelledby="faq_one"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  These costs can spiral but that didn't seem
                                  fair. So our prices work differently. Small
                                  businesses often need to do similar things:
                                  sell online, book appointments, make
                                  reservations. So we offer cheaper,
                                  pre-packaged Studio Store apps - that solve
                                  these brilliantly.
                                </p>
                                <p class="ct_fs_20 mb-0 ct_line_h_30">
                                  If you’re doing something new, on a bigger
                                  scale, or need more flexibility, then Builder
                                  Studio is for you. Prices vary depending on
                                  the features you need but again, you’ll know
                                  exactly what you’re paying upfront.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqtwo">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Two"
                                aria-expanded="true"
                                aria-controls="collapseTwo"
                              >
                                How does the mentorship work?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Two"
                              class="accordion-collapse collapse "
                              aria-labelledby="faqtwo"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  These costs can spiral but that didn't seem
                                  fair. So our prices work differently. Small
                                  businesses often need to do similar things:
                                  sell online, book appointments, make
                                  reservations. So we offer cheaper,
                                  pre-packaged Studio Store apps - that solve
                                  these brilliantly.
                                </p>
                                <p class="ct_fs_20 mb-0 ct_line_h_30">
                                  If you’re doing something new, on a bigger
                                  scale, or need more flexibility, then Builder
                                  Studio is for you. Prices vary depending on
                                  the features you need but again, you’ll know
                                  exactly what you’re paying upfront.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqthree">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Three"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Three"
                              >
                                Will I get access to high-profile clients?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Three"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqthree"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  These costs can spiral but that didn't seem
                                  fair. So our prices work differently. Small
                                  businesses often need to do similar things:
                                  sell online, book appointments, make
                                  reservations. So we offer cheaper,
                                  pre-packaged Studio Store apps - that solve
                                  these brilliantly.
                                </p>
                                <p class="ct_fs_20 mb-0 ct_line_h_30">
                                  If you’re doing something new, on a bigger
                                  scale, or need more flexibility, then Builder
                                  Studio is for you. Prices vary depending on
                                  the features you need but again, you’ll know
                                  exactly what you’re paying upfront.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqFour">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Four"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Four"
                              >
                                What kind of resources will I have access to?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Four"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqFour"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  These costs can spiral but that didn't seem
                                  fair. So our prices work differently. Small
                                  businesses often need to do similar things:
                                  sell online, book appointments, make
                                  reservations. So we offer cheaper,
                                  pre-packaged Studio Store apps - that solve
                                  these brilliantly.
                                </p>
                                <p class="ct_fs_20 mb-0 ct_line_h_30">
                                  If you’re doing something new, on a bigger
                                  scale, or need more flexibility, then Builder
                                  Studio is for you. Prices vary depending on
                                  the features you need but again, you’ll know
                                  exactly what you’re paying upfront.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xxl-5  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5 "
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div class="ct_about_img">
                      <img
                        src="assets/img/pexels-fauxels_456.png"
                        class="ct_img_h_617"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <section
            data-aos="fade-right"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg   ct_looking_for_work_bg_left   ct_p_111_y_106 ct_mt_100"
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">
                  Reach New Heights in Your Freelance Career
                </h4>
                <p class="mb-0 ct_fs_18 ct_fw_300">
                  Access top-tier projects, exclusive mentorship, and the tools
                  to build your legacy.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  onClick={() => navigate(coachPaths?.WebinarData)}
                >
                  View Workshop
                </a>
              </div>
            </div>
          </section>

          <section
            className="ct_px_40 ct_py_130 pb-0 ct_mb_100"
            data-aos="fade-down"
            data-aos-duration="1500"
          >
            <div className="container-fluid">
              {/* convert into slider */}
              <div className="row">
                <div className="col-lg-4 col-md-6 mb-4">
                  <div class="ct_testimonial_review_card h-100 d-grid">
                    <div>
                      <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                        <div class="d-flex align-items-center gap-1">
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        </div>
                        <p className="mb-0 ct_fs_16">20th April, 2025</p>
                      </div>
                      <p className="mb-0 " style={{ maxWidth: "295px" }}>
                        The expert sessions and networking inside NuForge are next level. I finally feel part of a serious community that pushes me to grow.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div class="d-flex align-items-center gap-3 ct_mt_40">
                        <img
                          src="/assets/img/Ellipse 24.png"
                          class="ct_img_60 "
                          alt=""
                        />
                        <div>
                          <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                            Alex Robertson
                          </h5>
                          <p class="mb-0  ct_fs_16  ">Frontend Developer</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4">
                  <div class="ct_testimonial_review_card h-100 d-grid">
                    <div>
                      <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                        <div class="d-flex align-items-center gap-1">
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        </div>

                        <p className="mb-0 ct_fs_16">20th April, 2025</p>
                      </div>
                      <p className="mb-0 " style={{ maxWidth: "295px" }}>
                        With NuForge, I refined my services, rebranded my profile, and doubled my client reach in just a few weeks. Totally worth it!
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div class="d-flex align-items-center gap-3 ct_mt_40">
                        <img
                          src="/assets/img/Ellipse 24 (1).png"
                          class="ct_img_60 "
                          alt=""
                        />
                        <div>
                          <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                            Olivia Brooks
                          </h5>
                          <p class="mb-0  ct_fs_16  ">Mobile App Developer</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4">
                  <div class="ct_testimonial_review_card h-100 d-grid">
                    <div>
                      <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                        <div class="d-flex align-items-center gap-1">
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        </div>

                        <p className="mb-0 ct_fs_16">20th April, 2025</p>
                      </div>
                      <p className="mb-0 " style={{ maxWidth: "295px" }}>
                        NuForge helped me position myself for higher-paying clients by improving my portfolio and strategy.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div class="d-flex align-items-center gap-3 ct_mt_40">
                        <img
                          src="/assets/img/Ellipse 24 (2).png"
                          class="ct_img_60 "
                          alt=""
                        />
                        <div>
                          <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                            James Thornton
                          </h5>
                          <p class="mb-0  ct_fs_16  ">Cloud Solutions Architect</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </MenuLayout>
  );
};

export default NuStarSubscription;
